import { render, staticRenderFns } from "./ColorStop.vue?vue&type=template&id=a5bea788&scoped=true"
import script from "./ColorStop.vue?vue&type=script&lang=js"
export * from "./ColorStop.vue?vue&type=script&lang=js"
import style0 from "./ColorStop.vue?vue&type=style&index=0&id=a5bea788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bea788",
  null
  
)

export default component.exports